import React from 'react';
import { ItemMetadata } from '../../../types/equipment';
import styles from './OfficialBadge.module.css';

interface OfficialBadgeProps {
  official: boolean;
  metadata?: ItemMetadata;
  variant?: 'inline' | 'standalone';
}

/**
 * OfficialBadge - Visual indicator of official SRD vs homebrew items
 * Shows "SRD" for official items, "HB" for homebrew items with author info on hover
 */
export const OfficialBadge: React.FC<OfficialBadgeProps> = ({
  official,
  metadata,
  variant = 'inline'
}) => {
  const badgeClass = official
    ? `${styles.badge} ${styles.official}`
    : `${styles.badge} ${styles.homebrew}`;

  const className = variant === 'standalone'
    ? `${badgeClass} ${styles.standalone}`
    : badgeClass;

  // Build tooltip for homebrew items
  const tooltipText = !official && metadata
    ? `Created by ${metadata.authorId || 'Unknown'} on ${
        metadata.createdAt
          ? new Date(metadata.createdAt).toLocaleDateString()
          : 'Unknown date'
      }`
    : undefined;

  return (
    <span
      className={className}
      title={tooltipText}
      aria-label={official ? 'Official item' : 'Homebrew item'}
    >
      {official ? 'SRD' : 'HB'}
    </span>
  );
};
